import { jsx as n } from "react/jsx-runtime";
import e from "react";
import { m as d } from "../chunks/breakpoints.907eaecd.js";
import { b as s } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { styled as c, css as o } from "styled-components";
const m = c.div.withConfig({
  displayName: "Container",
  componentId: "sc-kx19cd-0"
})(["all:unset;background-color:var(--elements-bg-color-02);border-radius:var(--default-border-radius);box-sizing:border-box;display:inline-flex;min-height:240px;min-width:240px;padding:var(--spacing-3x);", " ", ""], ({
  $clickable: r
}) => r && o`
      cursor: pointer;
      transition-property: background, opacity;
      transition-timing-function: var(--curve-productive-exit);
      transition-duration: var(--duration-fast-02);

      &:hover {
        background: var(--elements-bg-color-02);
        opacity: var(--hover-container);
        transition-timing-function: var(--curve-productive-entrance);
      }

      &:focus-visible {
        ${s}
        outline-offset: 2px;
      }
    `, d.sm(o`
    width: 100%;
  `)), p = e.forwardRef(({
  clickable: r = !1,
  children: a,
  ...t
}, i) => /* @__PURE__ */ n(m, { tabIndex: r ? 0 : void 0, $clickable: r, ref: i, as: r ? "button" : "div", "data-testid": "rango-card", "data-rango-component": "rango-card", "data-is-rango": !0, ...t, children: a }));
p.displayName = "RangoCard";
export {
  p as RangoCard
};
